import { render, staticRenderFns } from "./TableBudgetEducationEvent.vue?vue&type=template&id=325c8112&scoped=true&"
import script from "./TableBudgetEducationEvent.vue?vue&type=script&lang=js&"
export * from "./TableBudgetEducationEvent.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetEducationEvent.vue?vue&type=style&index=0&id=325c8112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c8112",
  null
  
)

export default component.exports